import { useExperimentValueSync } from "src/lib/useExperimentValue";

export default function usePaymentPageExperimentValue() {
  const experimentName = "payment_page";
  const fallbackButtonText = "SUBMIT PAYMENT";
  const fallbackTitleText = "Payment";
  const fallbackBodyText =
    "Want to use your HSA? Annual subscriptions qualify. Enter your HSA card details below.";

  const buttonText = useExperimentValueSync(
    experimentName,
    "buttonText",
    fallbackButtonText
  );
  const titleText = useExperimentValueSync(
    experimentName,
    "titleText",
    fallbackTitleText
  );
  const bodyText = useExperimentValueSync(
    experimentName,
    "bodyText",
    fallbackBodyText
  );

  return { buttonText, titleText, bodyText };
}
